import * as React from 'react';
import { TextField } from '@fluentui/react';
import { ConfigManager } from '../../Manager/ConfigManager';
const strippedOutExclusionPunctuationsRex =
	ConfigManager.getStrippedOutExclusionPunctuations();

interface AppProps {
	renderLabelWithTooltip;
	setUnsaveExclusionsValue;
	customExclusion: string[];
}

interface AppState {
	//
	text: string;
}

class CustomExclusionText extends React.Component<AppProps, AppState> {
	constructor(props, context) {
		super(props, context);
		this.state = { text: this._a2S(props.customExclusion) };
	}

	componentDidUpdate(prevProps: AppProps, _prevState) {
		if (prevProps.customExclusion !== this.props.customExclusion) {
			this.setState({ text: this._a2S(this.props.customExclusion) });
		}
	}

	private _a2S = (a: string[]): string => {
		let result: string = '';

		a &&
			a.forEach((item) => {
				result += result !== '' ? '\n' + item : item;
			});

		return result;
	};

	private _s2A = (s: string): string[] => {
		let result: string[];
		result = s.split('\n');
		return result;
	};

	render() {
		let { renderLabelWithTooltip, setUnsaveExclusionsValue } = this.props;
		return (
			<TextField
				label="Custom word exclusions"
				onRenderLabel={() =>
					renderLabelWithTooltip(
						'Custom word exclusions',
						'If you use certain keywords frequently (e.g. “education”) and feel that they are skewing your diagnosis, you can exclude them from the word count by typing them into the text box.',
					)
				}
				multiline
				value={this.state.text}
				onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
					this.setState({ text: ev.target.value });
				}}
				onBlur={(_ev: React.FocusEvent<HTMLTextAreaElement>) => {
					let textArray = this._s2A(this.state.text);
					const strippedWords = textArray.map((word) =>
						word.toLowerCase().replace(strippedOutExclusionPunctuationsRex, ''),
					);
					this.setState({ text: this._a2S(strippedWords) });
					setUnsaveExclusionsValue('customExclusion', strippedWords);
				}}></TextField>
		);
	}
}

export default CustomExclusionText;
